import {Component, Input} from '@angular/core';
import { ILineChart } from 'app/rpa-bots/uipath/common/models/ILineChart';
import {Chart} from 'chart.js';

@Component({
  selector: 'bz-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent  {

  @Input() dataChart: ILineChart;
  @Input() title: string;
  @Input() idChart: string;
  @Input() tabIndex: number;
  @Input() myIndex: number;

  chart: any;

  constructor() {
  }

  refresh() {
    if (!this.dataChart) {
      return;
    }

    const config = {
      options: {
        title: {
          display: true,
          position: 'top',
          text: this.title,
          fontSize: 20,
          fontColor: '#272727',
          fontFamily: '\'Open Sans\', Verdana, Serif',
          fontStyle: 'italic'
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontSize: 12,
            fontFamily: '\'Open Sans\', Verdana, Serif',
            fontStyle: 'italic'
          }
        }
      },
      type: 'line',
      data: JSON.parse(JSON.stringify(this.dataChart))
    };
    const canvasChart = document.getElementById(this.idChart) as HTMLCanvasElement;
    if (!canvasChart) {
      return;
    }

    const ctx = canvasChart.getContext('2d');

    this.chart = new Chart(ctx, config);
  }

}
